import { FC } from "react";
import { Menu, Text } from "@chakra-ui/react";

import { CaseDocumentFileModel } from "@shared/models";
import { ExternalLinkIcon } from "@shared/components/Icons";
import { FONT_WEIGHT } from "@assets/theme/foundations/textStyle";
import { pluralize } from "@containers/Cases/utils/caseDocuments";

import CaseDocumentFileTag from "./CaseDocumentFileTag";

interface CaseDocumentFileMenuItemsProps {
  title: string;
  files: CaseDocumentFileModel[];
  onView: (file: CaseDocumentFileModel) => void;
}

const CaseDocumentFileMenuItems: FC<CaseDocumentFileMenuItemsProps> = ({ title, files, onView }) => (
  <Menu.ItemGroup>
    <Menu.ItemGroupLabel
      px={3}
      pt={2}
      pb="6px"
      fontSize="11px"
      fontWeight={FONT_WEIGHT.BOLD}
      letterSpacing="0.08em"
      textTransform="uppercase"
      color="brand.emptyStateText"
    >
      {title} · {pluralize(files.length, "file")}
    </Menu.ItemGroupLabel>
    {files.map((file) => (
      <Menu.Item
        key={file.id}
        value={String(file.id)}
        onClick={() => onView(file)}
        gap="10px"
        w="300px"
        px={3}
        py="10px"
        borderRadius="8px"
        _highlighted={{ bg: "brand.chatMessageBg" }}
      >
        <CaseDocumentFileTag file={file} />
        <Text truncate flex={1} fontSize="14px" color="brand.modalHeaderText">
          {file.name}
        </Text>
        <ExternalLinkIcon boxSize={4} color="brand.emptyStateText" />
      </Menu.Item>
    ))}
  </Menu.ItemGroup>
);

export default CaseDocumentFileMenuItems;
